"use client"

import { cdn } from "common/utils/cdn"
import { useTranslations } from "next-intl"

import Style from "./index.module.scss"

const EmptyYet = () => {
	const t = useTranslations("DetailPage.empty")

	return (
		<div className={Style.emptyYet}>
			<img src={`${cdn()}/images/index/empty.png`} alt="empty" />
			<span>{t("noDataYet")}</span>
		</div>
	)
}

export default EmptyYet
